<div class="line-wrapper">
  <div class="form-field-maxi little-chip">
    <app-form-field-select-autocomplete
      *ngIf="foodFormControl"
      [control]="getFormControl()"
      [withDefault]="false"
      [completeList]="marketingFoods"
      [useKeyAndName]="!requestedFoodMode()"
      [showBracket]="false"
      [showLabel]="false"
      appearance="fill"
      [minAutocompleteLength]="2"
      [singleValueMode]="true"
      (inputValueChanged)="inputValueChange($event)"
      [chipColor]="requestedFoodMode() ? 'warn' : 'primary'"
    ></app-form-field-select-autocomplete>
  </div>
</div>
<div class="line-wrapper line-suggestions" *ngIf="!(foodFormControl && foodFormControl.value) && suggestedMarketingFoods.length">
  <button
    mat-raised-button
    *ngFor="let suggestedFood of suggestedMarketingFoods"
    class="btn btn-transparent btn-suggestion"
    (click)="selectFood(suggestedFood)"
  >
    <span>{{ getMarketingFoodText(suggestedFood) }}</span>
    <i class="fas fa-plus space-l-m" aria-hidden="true"></i>
  </button>
</div>
